export default __webpack_public_path__ + "static/media/franchises-icon1.fcf1d218.svg";